import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/shared/context/AuthProvider';

const PublicRoutes = () => {
  const { user } = useAuth();

  return user ? <Navigate to="/" replace /> : <Outlet />;
};
export default PublicRoutes;
